var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7599 0L1.051 0.707047L2.22668 1.88279C1.26407 2.53232 0.49478 3.42983 0.00012207 4.48046C0.481275 5.50759 1.22493 6.38957 2.15598 7.03736C3.08703 7.68516 4.17253 8.07587 5.30286 8.16996C6.20725 8.15785 7.099 7.95553 7.92008 7.57618L9.30488 8.96098L10.0119 8.25197L1.7599 0ZM5.30286 0.791016C4.74868 0.839664 4.2032 0.95986 3.67988 1.14858L5.08417 2.55483C5.23069 2.51961 5.38066 2.50124 5.53135 2.50004C6.05655 2.5002 6.56023 2.70889 6.9316 3.08027C7.30298 3.45164 7.51172 3.95526 7.51189 4.48046C7.51131 4.63108 7.49353 4.78116 7.45895 4.92776L9.27143 6.74024C10.0314 6.13189 10.6437 5.35928 11.0625 4.48046C10.5452 3.38704 9.73079 2.46122 8.71225 1.80879C7.69372 1.15636 6.51225 0.803664 5.30274 0.791016H5.30286ZM3.82636 3.48241L6.53136 6.18752C6.22822 6.36589 5.88307 6.46035 5.53135 6.46117C5.00615 6.46101 4.50259 6.25226 4.13121 5.88089C3.75984 5.50951 3.55109 5.0059 3.55093 4.48069C3.55267 4.12946 3.64779 3.78502 3.82648 3.48264L3.82636 3.48241Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0625,
    height: 8.96094,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordHide);
export default __webpack_public_path__ + "static/media/icon_password_hide.401d6dec9f796292fbd38687720aaed3.svg";
export { ForwardRef as ReactComponent };